"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Folder = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19,17.5 C19,17.775 18.776,18 18.5,18 L5.5,18 C5.224,18 5,17.775 5,17.5 L5,8 L18.5,8 C18.776,8 19,8.225 19,8.5 L19,17.5 Z M5,5.5 C5,5.225 5.224,5 5.5,5 L10.965,5 C11.132,5 11.288,5.083 11.381,5.223 L12.566,7 L5,7 L5,5.5 Z M18.5,7 L13.818,7 L13.768,7 L12.213,4.668 C11.934,4.25 11.467,4 10.965,4 L5.5,4 C4.673,4 4,4.673 4,5.5 L4,7 L4,8 L4,17.5 C4,18.327 4.673,19 5.5,19 L18.5,19 C19.327,19 20,18.327 20,17.5 L20,8.5 C20,7.673 19.327,7 18.5,7 L18.5,7 Z", fillRule: "evenodd" })));
};
Folder.displayName = 'Folder';
exports.default = Folder;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Folder.js.map